import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import { PARAMS } from "../util/GlobalConstants";

const LoaderBox = ({
  message,
  backdrop = true,
  size = "lg",
  className: newClassName = "",
}) => {
  const theme = useSelector((state) => state.theme.currentTheme);

  return (
    <div
      className={
        "flex-container-column small-content table-message " + newClassName
      }
    >
      <Loader
        size={size}
        className="m-auto"
        content={message}
        inverse={theme === PARAMS.theme.dark ? true : false}
        backdrop={backdrop}
      />
    </div>
  );
};

export default LoaderBox;
